(ns ui.editors.entity-creator.model)

(def config-defs
  {:system-mandatory
   {:label "System Level Mandatory"
    :icon  "fa-cogs"}
   :not-shown
   {:label "Not Shown"
    :icon  "fa-ban"}
   :optional
   {:label "Optional"
    :icon  "fa-circle"}
   :mandatory
   {:label "Mandatory"
    :icon  "fa-asterisk"}
   :mandatory-inherited
   {:label "Mandatory inherited"
    :icon  "fa-asterisk"}
   :use-default-locked
   {:label "Default value - Locked"
    :icon  "fa-user-lock"}
   :use-default-hidden
   {:label "Default value - Hidden"
    :icon  "fa-eye-slash"}})

(def config-options
  [:not-shown
   :optional
   :mandatory
   ;; implemented later:
   #_:use-default-locked
   #_:use-default-hidden])

(def root ::state)
(def root-path [root])

(def open-key :open?)
(def open-path [open-key])
(def open-full-path
  (conj root-path open-key))

(def saving-key :saving?)
(def saving-path [saving-key])
(def saving-full-path
  (conj root-path saving-key))

(def entity-type-key :entity-type)
(def entity-type-path [entity-type-key])
(def entity-type-full-path
  (conj root-path entity-type-key))

(def target-type-key :target-type)
(def target-type-path [target-type-key])
(def target-type-full-path
  (conj root-path target-type-key))

(def pipeline-key :pipeline)
(def pipeline-path [pipeline-key])
(def pipeline-full-path
  (conj root-path pipeline-key))

(def edits-key :edits)
(def edits-path [edits-key])
(def edits-full-path
  (conj root-path edits-key))

;; either single entity listing without pipeline, only creation
;; e.g. company: select attributes + define one :config (:optional, :mandatory etc)
;;OR
;; pipeline-specific,

;; Coeffects
(def stages-cofx ::stages-cofx)
(def tenant-cofx ::tenant-cofx)
(def system-mandatory-cofx ::system-mandatory-cofx)
(def field-schemas-cofx ::field-schemas-cofx)

;; Subscriptions
(def state ::state)
(def open? ::open?)
(def saving? ::saving?)
(def changes? ::changes?)
(def pipeline ::pipeline)
(def pipeline-name ::pipeline-name)
(def stages ::stages)
(def system-mandatory ::system-mandatory)
(def stages-config ::stages-config)
(def association-stages-config ::association-stages-config)
(def create-config ::create-config)
(def entity-type ::entity-type)
(def target-type ::target-type)
(def edits ::edits)
(def edited-config ::edited-config)
(def title ::title)
(def layout ::layout)
(def config ::config)
(def associations-config ::associations-config)
(def available-fields ::available-fields)
(def inactive-field ::inactive-field)
(def teams-without-write-access ::teams-without-write-access)

(def available-association-options ::available-association-options)

;; Events
(def open-config ::open-config)
(def close-config ::close-config)
(def add-attribute ::add-attribute)
(def remove-attribute ::remove-attribute)
(def add-association ::add-association)
(def remove-association ::remove-association)
(def update-field-config ::update-field-config)
(def set-entry-criteria-mode ::set-entry-criteria-mode)
(def update-field-visibility ::update-field-visibility)
(def update-association-prefill ::update-association-prefill)
(def update-association-visibility ::update-association-visibility)
(def edit-default-value ::edit-default-value)
(def reorder-fields ::reorder-fields)
(def reorder-associations ::reorder-associations)
(def save-config ::save-config)
(def save-config-success ::save-config-success)
(def save-config-error ::save-config-error)
(def replace-config-at-path ::replace-config-at-path)
(def toggle-prevent-create ::toggle-prevent-create)
(def toggle-prevent-create-success ::toggle-prevent-create-success)
(def toggle-prevent-create-error ::toggle-prevent-create-error)
